import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type REVENUE_TARGET_TYPES} from 'web-app/react/plans/revenue-report/constants';

const domain = 'INSTITUTION_REVENUE_DETAILS';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH_REVENUE_DATA`,
    (targetId: string, targetType: REVENUE_TARGET_TYPES, year: string, refresh: boolean) => ({
        targetId,
        targetType,
        year,
        refresh,
    }),
    response => ({response}),
);
